import React, { Component } from 'react';
import { Card, CardBody, Button, Input, Form } from 'reactstrap';
import Dropzone from 'react-dropzone';
import FontAwesome from 'react-fontawesome';
import { Editor } from '@tinymce/tinymce-react';

export default class TextEditor extends Component {
  constructor() {
    super();
    this.state = {
      shouldShowDropzone: false,
    };
  }
  onChange(value) {
    this.props.onChangeBody(value)
  }

  setEditor(editor) {
    this.props.setEditor(editor)
  }
  onDrop = (acceptedFiles, rejectedFiles) => {
    const { onAddFiles } = this.props;
    Array.prototype.push.apply(acceptedFiles, rejectedFiles);
    onAddFiles(acceptedFiles);
    this.hideDropzone();
  }
  showDropzone = () => this.setState({ shouldShowDropzone: true })
  hideDropzone = () => this.setState({ shouldShowDropzone: false })
  onClickHideDropzone = e => {
    e.stopPropagation();
    this.hideDropzone();
  };
  getRandomInt() {
    return new Date().getTime();
  }
  render() {
    const { inputId = '', disabled, rows, files, placeholder, is_comment, className = '', initialValue = '', isReplying = false } = this.props;
    const { shouldShowDropzone } = this.state;
    return (
      <div className="text-editor" onDragEnter={this.showDropzone}>
        <div className="textarea-container">
          <Editor
            className={className}
            id={`${inputId}-${this.getRandomInt()}`}
            onEditorChange={(content, editor) => {this.onChange(content)}}
            disabled={disabled}
            rows={rows}
            onInit={(evt, editor) => this.setEditor(editor)}
            initialValue={initialValue}
            textareaName={is_comment ? 'description_comment' : 'description_box'}
            init={{
              height: 140,
              menubar: false,
              toolbar: false,
              statusbar: false,
              placeholder: placeholder,
              inline_boundaries: false,
              forced_root_block: 'div',
              // FIX 20260730-pasteimg: 貼り付け時に埋め込み画像(base64)を取り込まない。
              //   WordやDocs等から貼ると画像が本文へ直接埋め込まれ、1件で1.4MB(本文の98%)まで肥大し、
              //   一覧カードで文字が押し下げられて見えなくなる・画面が重くなる原因になっていた。
              //   文字と装飾は従来どおり貼り付けできる。画像は添付ファイル機能を使う。
              paste_data_images: false,
              // FIX 20260731-pasteimg2: paste_data_images は埋め込み画像(base64)しか止めず、
              //   WEBサイトから貼ると外部リンク画像(<img src="https://...">)がそのまま入っていた。
              //   実測で1コメント84個。表示のたび外部サーバーへ取りに行くため重く、
              //   相手サイトが画像を消すと壊れた表示になる。貼り付け時に img を取り除く。
              //   文字・表・太字・色・下線の貼り付けは従来どおり。画像は添付ファイル機能を使う。
              paste_preprocess: function (plugin, args) {
                try { args.content = String(args.content || "").replace(/<img[^>]*>/gi, ""); } catch (e) {}
              },
              auto_focus : inputId,
              content_style: isReplying ? '.mce-content-body { margin-top: 32px !important; word-break: break-all !important; overflow-wrap: break-word !important; white-space: pre-wrap !important; }' : 'body { word-break: break-all !important; overflow-wrap: break-word !important; white-space: pre-wrap !important; }',
            }}
            autoFocus />
          {
            shouldShowDropzone && (
              <Dropzone className="dropzone row justify-content-center align-items-center" onDrop={this.onDrop} accept="image/*">
                <div className="col-12">
                  Drop image here or select a file.
                  <a href="#" className="ml-3" onClick={this.onClickHideDropzone}>
                    Close
                  </a>
                </div>
              </Dropzone>
            )
          }
        </div>
      </div>
    )
  }
}
